export default function hideLoader(permanent = false) {
    const loader = document.getElementById('global-loader');
    const styles = document.getElementById('global-loader-styles');

    return new Promise((resolve) => {
        if (!permanent) {
            setTimeout(() => {
                loader.classList.add('opacity-0');
            }, 750);
        }

        setTimeout(() => {
            loader?.remove();
            styles?.remove();
        }, permanent ? 0 : 1500);

        resolve(true);
    });
}
